<template>
  <div :class="['btn', type, { disabled: disabled }]">
    <button
      v-if="prevent"
      ref="blueButton"
      :disabled="disabled"
      tabindex="0"
      type="submit"
      @click.prevent="onClick()"
    >
      {{ label }}
    </button>

    <button
      v-else
      :disabled="disabled"
      tabindex="0"
      type="submit"
      @click="onClick()"
    >
      {{ label }}
    </button>
  </div>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'btn-blue'
      },
      prevent: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onClick() {
        this.$emit('clicked')
      }
    }
  }
</script>

<style
  lang="scss"
  rel="stylesheet/scss"
  scoped
>
  @import '~assets/styles/common.scss';
  @import '~assets/styles/components/icons.scss';

  .btn.disabled {
    background: $grey-border;

    button {
      cursor: default;
      color: rgba($blue-dark, 0.4);
    }
  }

  .btn {
    height: 48px;

    button {
      line-height: 48px;

      @include outline-focus;
    }

    &-green {
      background: $green-base;
      color: $blue-dark;
      height: 48px;
      line-height: 48px;
      font-size: rem(16, 16);

      &:focus-within,
      &:hover {
        background: $green-hover;
      }

      @include bp-mf-desktop {
        height: 52px;
        line-height: 52px;
      }

      button {
        height: 48px;
        color: $blue-dark;

        @include bp-mf-desktop {
          height: 52px;
        }
      }
    }

    &-blue-dark {
      height: 56px;
      background: $dark-blue;
      color: white;
      border-radius: 4px;

      @include bp-mf-tablet {
        min-width: 280px;
        max-width: auto;
      }

      button {
        height: 56px;
        color: white;
        font-size: em(16, 16);
        line-height: 26px;
        font-weight: 500;
      }
    }

    &-ghost {
      border: 1px solid $dark-blue;
      color: $dark-blue;
      border-radius: 4px;

      button {
        color: $dark-blue;
        font-size: em(16, 16);
        font-weight: 500;
      }
    }

    &-ghost-large {
      height: 56px;
      border: 1px solid $dark-blue;
      color: $dark-blue;
      border-radius: 4px;

      button {
        height: 56px;
        color: $dark-blue;
        font-size: em(16, 16);
        line-height: 26px;
        font-weight: 500;
      }
    }

    &-ghost-green {
      border: 1px solid $green-base;
      color: $blue-dark;
      font-size: em(16);
      height: 48px;
      line-height: 48px;

      @include bp-mf-desktop {
        height: 52px;
        line-height: 52px;
      }

      &:hover,
      &:focus-within {
        background: $green-hover;
      }
    }

    &-cookie,
    &-cookie__dark-blue {
      font-size: rem(16, 16);
      border-radius: 4px;
      width: 100%;
      height: unset;

      button {
        padding: 16px 32px;
        line-height: unset;
      }
    }

    &-cookie__dark-blue {
      background-color: $dark-blue;
      color: white;
    }

    &-cookie {
      border: 1px solid $dark-blue;
      color: $dark-blue;

      button {
        &:hover {
          background-color: $dark-blue;
          color: white;
        }
      }
    }

    &-chevron-down {
      button {
        &:after {
          @extend .i;
          @extend .i-chevron-down;
          margin-left: 8px;
        }
      }
    }

    &-chevron-up {
      button {
        &:after {
          @extend .i;
          @extend .i-chevron-up;
          margin-left: 8px;
        }
      }
    }
  }

  .btn-blue-ui {
    background: $blue-dark-ui;
    font-size: em(16);
    color: white;
    font-weight: 500;
    line-height: 24px;
    border-radius: 4px;
    width: 100%;
    height: 48px;

    @include bp-mf-tablet {
      min-width: 192px;
    }

    button {
      padding: 0 16px;
    }
  }

  .btn-scn {
    background: $blue-scn;
    height: 48px;
    border-radius: 4px;
    width: 100%;
    margin-bottom: 16px !important;

    button {
      padding: 0 16px;
      color: white;
      line-height: 48px;
      font-weight: 500;
      font-size: rem(16, 16);

      @include bp-mf-tablet {
        padding: 0 24px;
        font-weight: 400;
      }
    }
  }

  .btn-dark {
    background: $blue-scn;
    border-radius: 8px;

    button {
      padding: 0 16px;
      color: white;
      font-weight: 500;
      font-size: rem(16, 16);
    }
  }
</style>
